// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/agent/v1/conversation.proto (package chalk.agent.v1, syntax proto3)
/* eslint-disable */

import { AgentConversationService } from "./conversation_pb";

/**
 * @generated from rpc chalk.agent.v1.AgentConversationService.CreateConversation
 */
export const createConversation = AgentConversationService.method.createConversation;

/**
 * @generated from rpc chalk.agent.v1.AgentConversationService.GetConversation
 */
export const getConversation = AgentConversationService.method.getConversation;

/**
 * @generated from rpc chalk.agent.v1.AgentConversationService.GetConversationForkFamily
 */
export const getConversationForkFamily = AgentConversationService.method.getConversationForkFamily;

/**
 * @generated from rpc chalk.agent.v1.AgentConversationService.ListConversations
 */
export const listConversations = AgentConversationService.method.listConversations;

/**
 * @generated from rpc chalk.agent.v1.AgentConversationService.UpdateConversation
 */
export const updateConversation = AgentConversationService.method.updateConversation;

/**
 * @generated from rpc chalk.agent.v1.AgentConversationService.DeleteConversation
 */
export const deleteConversation = AgentConversationService.method.deleteConversation;

/**
 * @generated from rpc chalk.agent.v1.AgentConversationService.ForkConversation
 */
export const forkConversation = AgentConversationService.method.forkConversation;

/**
 * @generated from rpc chalk.agent.v1.AgentConversationService.LinkArtifact
 */
export const linkArtifact = AgentConversationService.method.linkArtifact;

/**
 * @generated from rpc chalk.agent.v1.AgentConversationService.UnlinkArtifact
 */
export const unlinkArtifact = AgentConversationService.method.unlinkArtifact;

/**
 * @generated from rpc chalk.agent.v1.AgentConversationService.ListArtifacts
 */
export const listArtifacts = AgentConversationService.method.listArtifacts;

/**
 * @generated from rpc chalk.agent.v1.AgentConversationService.ListConversationsForArtifact
 */
export const listConversationsForArtifact = AgentConversationService.method.listConversationsForArtifact;

/**
 * @generated from rpc chalk.agent.v1.AgentConversationService.AddMessage
 */
export const addMessage = AgentConversationService.method.addMessage;

/**
 * @generated from rpc chalk.agent.v1.AgentConversationService.UpdateMessageStatus
 */
export const updateMessageStatus = AgentConversationService.method.updateMessageStatus;

/**
 * @generated from rpc chalk.agent.v1.AgentConversationService.SetMessageFeedback
 */
export const setMessageFeedback = AgentConversationService.method.setMessageFeedback;

/**
 * @generated from rpc chalk.agent.v1.AgentConversationService.ListMessages
 */
export const listMessages = AgentConversationService.method.listMessages;

/**
 * @generated from rpc chalk.agent.v1.AgentConversationService.AddToolResult
 */
export const addToolResult = AgentConversationService.method.addToolResult;

/**
 * Admin-only transcript editing, for re-working conversations (e.g. demos).
 *
 * @generated from rpc chalk.agent.v1.AgentConversationService.ReplaceConversationTranscript
 */
export const replaceConversationTranscript = AgentConversationService.method.replaceConversationTranscript;

/**
 * Admin-only: re-point (or detach) the notebook a conversation is bound to.
 *
 * @generated from rpc chalk.agent.v1.AgentConversationService.SetConversationNotebook
 */
export const setConversationNotebook = AgentConversationService.method.setConversationNotebook;

/**
 * Admin-only: insert a pre-built agent trace into the environment's
 * telemetry store (demo re-working).
 *
 * @generated from rpc chalk.agent.v1.AgentConversationService.UploadAgentTrace
 */
export const uploadAgentTrace = AgentConversationService.method.uploadAgentTrace;
